import React from 'react'
import styled from 'styled-components'

import Button from '../../../../../1stlog-ui/src/components/Button'
import Tooltip from '../../../../../1stlog-ui/src/components/Tooltip'

const Wrapper = styled.div`
  // border 1px solid lime;
  // padding: 1px 0;
  // cursor: pointer;
  margin-top: -1px;

  background: #f3f7f9 !important;
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 10px;

  :hover {
    // background: rgba(0, 0, 0, 0.03);
  }
`

const Inner = styled.div`
  // margin: 5px 0;
`

const TraceWrapper = styled.div`
  background: #f3f7f9 !important;
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 10px;
`

const Item = (props) => {
  const { meta, onSelect, trace } = props

  const { name, description, ztnFull } = meta

  const [, ...actualTrace] = trace

  const selectItem = () => {
    // console.log("trace", trace)
    onSelect({
      isFromTariffDatabase: true,
      tariffNumber: ztnFull,
      description,
      trace: [...actualTrace, meta],
    })
  }

  return (
    <Wrapper aonClick={selectItem}>
      <Inner className="d-flex align-items-center">
        <div className="mr-2">
          <strong>{ztnFull}</strong>
        </div>
        <div className="flex-fill d-flex">
          <div>{description}</div>
          <div className="ml-2">
            <Tooltip
              tooltip={i18n.t('click_to_apply', 'Zum Übernehmen klicken')}
            >
              <Button
                textOnly
                hasStyle
                info
                xs
                icon="far fa-plus"
                onClick={selectItem}
              >
                {i18n.t('apply', 'Übernehmen')}
              </Button>
            </Tooltip>
          </div>
        </div>
      </Inner>
    </Wrapper>
  )
}

export default Item
